export default __webpack_public_path__ + "static/Rectangle4386-0e9c912a15203c3adf6078e3d241c8f7.png";